import React, { useEffect, useMemo } from "react";
import svg16 from "../../../../assets/svg/svg16.svg";
import svg20 from "../../../../assets/svg/svg20.svg";
import svg21 from "../../../../assets/svg/svg21.svg";
import svg22 from "../../../../assets/svg/svg22.svg";
import svg23 from "../../../../assets/svg/svg23.svg";
import svg24 from "../../../../assets/svg/svg24.svg";
import svg25 from "../../../../assets/svg/svg25.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatText, numberWithCommas } from "../../../../utils";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import CardLoading from "../../../../components/CardLoading";

function Header() {
  const dispatch = useDispatch();
  const urlSchCard = "sch/get_dashboard";
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));
  const { loading, dataSchCard } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataSchCard: state.fetch.data[urlSchCard] || [],
  }));

  const navigate = useNavigate();
  const items = [
    {
      title: "IWUA",
      link: "/scheme/iwua-list",
    },
    {
      title: "Crop Produce & Market",
      link: "/scheme/crop-produce",
    },
    {
      title: "Non Spatial Data",
      link: "/scheme/non-spatial-list",
    },
    {
      title: "Performance KPI",
      link: "/rob/scheme/indicators-list",
    },
    {
      title: "Associated Projects",
      link: "/rob/scheme/associated-project-list",
    },
  ];

  const svgMap = {
    svg20,
    svg21,
    svg22,
    svg23,
    svg24,
    svg25,
  };

  const processedData = useMemo(() => {
    return dataSchCard?.map((item) => ({
      ...item,
      svg: svgMap[item?.svg],
    }));
  }, [dataSchCard]);

  async function fetchCardData() {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: activeObjSchemes?.schId,
        limit: null,
        start: 0,
      })
    );
  }
  useEffect(() => {
    fetchCardData();
  }, [activeObjSchemes?.schId]);
  if (loading) return <CardLoading />;

  return (
    <div className="mt-[2.06rem] white_card">
      <div className="form-add-h">{activeObjSchemes?.schName}</div>
      <div className="mt-[.62rem] gap-x-[.62rem] text-[.875rem] font-[400] text-[rgba(0,0,0,0.60)] flex items-center">
        <span>{formatText(activeObjSchemes?.schSchemeType)}</span>
        <span>•</span>
        <span>{activeObjSchemes?.schCountyName}</span>
        <span
          className="gap-[.625rem] flex items-center 
        justify-center rounded-[.5rem] bg-[#E5E8E9] px-[.25rem] py-[.125rem] max-w-[6.875rem] text-[#393939] font-interSans text-[0.625rem]"
        >
          Survey
        </span>
      </div>

      <div className="mt-[1.75rem] flex flex-shrnk flex-wrap items-center gap-[.63rem]">
        {items &&
          items?.map((item) => (
            <div
              className="cursor-pointer border border-[#D6E1F5] bg-white px-[.75rem] py-[.5rem] gap-[.5rem] flex rounded-[.375rem]"
              onClick={() => navigate(item?.link ?? null)}
            >
              <span className="text-[.875rem] font-[500] font-interSans text-black1">
                {item?.title}
              </span>
              <img src={svg16} alt="svg16" />
            </div>
          ))}
      </div>

      <div className="mt-[2.5rem] flex flex-shrink flex-wrap gap-[1.56rem]">
        {processedData &&
          processedData?.map((item) => (
            <>
              {" "}
              <div className="rounded-[.75rem] border border-[#D6E1F5] bg-[#F7F7F7] h-[6.25rem] lg:w-[13.75rem] w-full p-[.5rem]">
                <div className="flex items-center justify-between">
                  <div className="scheme-card-title">{item?.title}</div>
                  <img src={item?.svg} alt={item?.svg} />
                </div>
                <div
                  className={`scheme-card-content mt-[1.62rem] ${
                    item?.count == 0 && "!text-[#DD2222]"
                  }`}
                >
                  {numberWithCommas(item?.count)}
                </div>
              </div>
            </>
          ))}
      </div>
    </div>
  );
}

export default Header;
